import { render, staticRenderFns } from "./fund.vue?vue&type=template&id=06f77500&scoped=true"
import script from "./fund.vue?vue&type=script&lang=js"
export * from "./fund.vue?vue&type=script&lang=js"
import style0 from "./fund.vue?vue&type=style&index=0&id=06f77500&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f77500",
  null
  
)

export default component.exports